import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="fixed h-full w-full bg-[#09090b]">
      <Helmet>
        <title>About</title>
        <meta name="description" content="learn more about ponchotang" />
      </Helmet>
      <Link to="/" className="absolute top-8 left-8 text-zinc-600 hover:text-zinc-400 text-sm transition-colors duration-150">← back</Link>
      <div className="h-full flex flex-col items-center justify-center p-8">
        <div className="w-72">
          <p className="text-zinc-600 text-xs tracking-widest uppercase mb-6">about</p>
          <h1 className="text-zinc-100 text-2xl font-medium">im andy</h1>
        </div>
      </div>
    </div>
  )
}
